var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 18.5C21 19.881 19.881 21 18.5 21H5.5C4.1195 21 3 19.881 3 18.5V5.5C3 4.119 4.1195 3 5.5 3H18.5C19.881 3 21 4.119 21 5.5V18.5Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.05,
    d: "M15 18.5V13.4505C15 12.606 14.5905 12.1015 13.904 12.1015C13.4965 12.1015 13.197 12.331 13.0145 12.7835C13.006 12.8155 12.994 12.946 12.999 13.3405L13 18.5H9.5V9H13V9.5305C13.511 9.178 14.1375 9 14.869 9C17.1425 9 18.4995 10.5465 18.4995 13.137L18.5 18.5H15ZM5.5 18.5V9H7.2285C6.227 9 5.5 8.264 5.5 7.2495C5.5 6.236 6.239 5.5 7.257 5.5C8.263 5.5 8.9795 6.2155 9 7.2395C9 8.2615 8.2605 9 7.2425 9H9V18.5H5.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.07,
    d: "M15.25 18.25V13.4505C15.25 12.464 14.7345 11.8515 13.904 11.8515C13.2565 11.8515 12.9365 12.3075 12.7825 12.69C12.7415 12.7895 12.747 13.1845 12.749 13.353L12.75 18.25H9.75V9.25H12.75V10.069C13.1475 9.6575 13.7875 9.25 14.869 9.25C16.9855 9.25 18.2495 10.703 18.2495 13.137L18.25 18.25H15.25ZM5.75 18.25V9.25H8.75V18.25H5.75ZM7.2285 8.75C6.372 8.75 5.75 8.119 5.75 7.2495C5.75 6.3805 6.384 5.75 7.257 5.75C8.119 5.75 8.7325 6.3645 8.75 7.2445C8.75 8.119 8.116 8.75 7.2425 8.75H7.2285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6 9.5H8.5V18H6V9.5ZM7.2425 8.5H7.2285C6.4825 8.5 6 7.944 6 7.2495C6 6.54 6.4975 6 7.257 6C8.0175 6 8.486 6.54 8.5 7.2495C8.5 7.9435 8.0175 8.5 7.2425 8.5ZM18 18H15.5V13.4505C15.5 12.3515 14.8875 11.6015 13.904 11.6015C13.1535 11.6015 12.7475 12.1075 12.5505 12.5965C12.4785 12.7715 12.5 13.2555 12.5 13.5V18H10V9.5H12.5V10.808C12.8605 10.25 13.425 9.5 14.869 9.5C16.658 9.5 17.9995 10.625 17.9995 13.137L18 18Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsLinkedIn);
export default __webpack_public_path__ + "static/media/WHSLinkedIn.888f3649b4ec8b4b01be6e6afd0a238b.svg";
export { ForwardRef as ReactComponent };